// @ts-nocheck
import React, { FC } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { checkoutProps } from "@store/Themes/common/props/checkout";
import { css } from "styled-components";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

type Props = WidgetProps;

interface MyAccountWrapperStyles {
    wrapper?: InjectableCss;
}

export const myAccountWrapperStyles: MyAccountWrapperStyles = {
    wrapper: {
        ...checkoutProps.contentWrapper,
        css: css`
            ${checkoutProps.contentWrapper?.css}
            padding: ${pxToRem(35)};
        `,
    },
};

const styles = myAccountWrapperStyles;

const MyAccountWrapper: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Zone contentId={id} zoneName="Content" />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MyAccountWrapper,
    definition: {
        group: "My Account",
        displayName: "Account Wrapper",
    },
};

export default widgetModule;
